import {WidgetDescription} from '../../components/layout/widget/widget-description';
import {DEX_TRANCHE_DETAILS_WIDGET_TYPE_ID} from './dex-tranche-details-widget-type-id';
import {DexTrancheDetailsWidgetComponent} from './dex-tranche-details-widget.component';
import {DexTrancheDetailsWidgetImplementation} from './dex-tranche-details-widget.implementation';
import {DexTrancheDetailsWidgetSettingsComponent} from './settings/dex-tranche-details-widget-settings.component';
import {DexTrancheDetailsWidgetSettingsService} from './settings/dex-tranche-details-widget-settings.service';

export const DEX_TRANCHE_DETAILS_WIDGET_DESCRIPTION: WidgetDescription = {
    widgetTypeId:                DEX_TRANCHE_DETAILS_WIDGET_TYPE_ID,
    widgetLabel:                 'components.widgets.dex-tranche-details-widget.widget_name',
    widgetImplementationType:    DexTrancheDetailsWidgetImplementation,
    widgetComponentType:         DexTrancheDetailsWidgetComponent,
    widgetSettingsServiceType:   DexTrancheDetailsWidgetSettingsService,
    settingsSchema:              [
        {
            name: 'title',
            isShareable: false
        },
        {
            name: 'symbol',
            sharedName: 'trancheSymbol',
            isShareable: true
        }
    ],
    hasGroupingSupport:          true,
    widgetSettingsComponentType: DexTrancheDetailsWidgetSettingsComponent
};
